<template>
  <div  v-loading="loading">
    <el-dialog ref='dialog' title="导入数据已存在">

      <!--导入数据-->
      <div class="content">
        <el-button type="text" @click="replaceAll('1')">全部覆盖</el-button>
        <el-button type="text" @click="replaceAll('0')">全部不导入</el-button>
        <el-table 
          :data='curArrRepeat'
          border
          max-height="500"
          style="width: 100%">
          <el-table-column label="处理方式" width="110">
            <template scope="scope"> 
              <el-radio class="radio" v-model="radioList[scope.$index]['type']" label="1">覆盖</el-radio>
              <el-radio class="radio" v-model="radioList[scope.$index]['type']" label="0">不导入</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="已存在检验配置中的配置字段" >
            <template scope="scope"> 
              <el-table 
                :data='arrRepeatRow[scope.$index]'
                border>
                <el-table-column v-for='uniqueCol in curUniqueField' :label="uniqueCol.title" >
                  <template scope="subscope">
                    <span> {{ scope.row[uniqueCol.name] }} </span>
                  </template>
                </el-table-column>
            </template>
          </el-table-column>
          <el-table-column label="所有导入字段" min-width="300">
            <template scope="scope"> 
              <el-table 
                :data='arrRepeatRow[scope.$index]'
                border
                style="width: 100%">
                <el-table-column v-for='fieldCol in curAllField' :label="fieldCol.title" min-width='200'>
                  <template scope="subscope">
                    <el-input v-model.trim="scope.row['cur' + fieldCol.name]" class="h-40" style="width:150px;" placeholder="输入修改内容"></el-input>
                    <div> {{ scope.row[fieldCol.name] }} </div>
                  </template>
                </el-table-column>
            </template>
          </el-table-column>
          </el-table-column>
        </el-table>
      </div>

      <div class="footer">
        <el-button @click="closeDialog()" >取消</el-button>
        <el-button type="primary"  @click="save()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
  .download{
    color: #4db3ff
  }
  .hr {
    clear:both;
    margin-bottom: 10px;
    margin-top:10px;
    height: 1px;
    background: #000000;
  }
  .el-radio+.el-radio {
    margin-left: 0px !important;
  }
  .el-dialog--small {
    width: 60%;
  }
  .el-table .tableColumnClass {
    height: 50px;
  }
  .footer {
    text-align: right;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
  }
  .selectMapName .el-form-item__content {
    float: left;
  }
  .content {
    max-height: 450px;
    overflow-y: auto;
  }
</style>
  
<script>
import http from '../../../assets/js/http'
export default {
  props: {
    repeatDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    importId: {
      type: Number,
      default() {
        return 0
      }
    },
    contentId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      loading: false,
      host: '',
      curArrRepeat: [],
      curUniqueField: [],
      curAllField: [],
      arrRepeatRow: [],
      postData: {},
      radioList: []
    }
  },
  created() {
    this.host = HOST
  },
  methods: {
    open() {
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    replaceAll(type) {
      _(this.radioList).forEach((radio) => {
        radio.type = type
      })
    },
    save() {
      let postData = []
      _(this.repeatDetail.arrRepeat).forEach((list, index) => {
        let arr = {}
        _(list).forEach((val, key) => {
          if (this.curArrRepeat[index]['cur' + key]) {
            arr[key] = this.curArrRepeat[index]['cur' + key]
          } else {
            arr[key] = val
          }
        })
        postData.push({ arr: arr, type: this.radioList[index]['type'] })
      })
      let data = {
        data: postData,
        log_id: this.repeatDetail.log_id
      }
      this.apiPost(`cms/contents/${this.contentId}/confirm_excel/${this.importId}`, data).then((res) => {
        if (res.code == 200) {
          _g.toastMsg(this, 'success', '操作成功！')
          this.$emit('handleRepeat')
          this.closeDialog()
        } else {
          _g.dealError(this, res)
        }
      })
    }
  },
  watch: {
    repeatDetail() {
      this.arrRepeatRow = []
      // console.log(this.repeatDetail)
      this.curArrRepeat = _.cloneDeep(this.repeatDetail.arrRepeat)
      this.curUniqueField = _.cloneDeep(this.repeatDetail.uniqueField)
      this.curAllField = _.cloneDeep(this.repeatDetail.allField)
      _(this.curArrRepeat).forEach((list) => {
        let rowArr = []
        rowArr.push(list)
        this.radioList.push({ type: "0" })
        this.arrRepeatRow.push(rowArr)
      })
      // console.log(this.curArrRepeat)
    }
  },
  mixins: [http]
}
</script>



// WEBPACK FOOTER //
// repeatDialog.vue?896b1b82